/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */
import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class DeleteUserService extends BaseService {
  constructor() {
    super(constants.DELETE_USER_DATA, 'tenantDeleteUserStatus');
    this.tenantName = null;
    this.deletedEmail = null;
  }

  handleEvent(eventName, payload) {
    const { email, tenantId, tenantName } = payload;
    this.tenantName = tenantName;
    this.deletedEmail = email;
    const headers = utils.buildHeadersWithTenantId({ tenantId });
    return this.getClient('aiadmin').post(`/users/delete`, { email }, { headers });
  }

  handleResponse(response) {
    const { data } = response;
    if (data.status === 'success') {
      Framework.getStoreRegistry().getStore('chatutilityusersState').setDeletedUserData(this.deletedEmail);
      const notification = {
        open: true,
        type: 'success',
        message: 'User deleted successfully'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
    Framework.redirectTo(`/aiadmin/${this.tenantName}/users`);
  }

  handleError(error) {
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    }
    Framework.redirectTo(`/aiadmin/${this.tenantName}/users`);
  }
}
